import type { IconProps } from "@mdi/react/dist/IconProps";
import { Icon } from "@mdi/react";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@acdc2/ui/components/accordion";

type Props = {
  value: string;
  iconPath: IconProps["path"];
  title: string;
  description: string;
  children?: React.ReactNode;
};

export function TableEditorStep({
  value,
  iconPath,
  title,
  description,
  children,
}: Props) {
  return (
    <AccordionItem value={value} className="px-4">
      <AccordionTrigger>
        <div className="flex items-center gap-4">
          <Icon path={iconPath} size="1.5rem" />
          <div>
            <div className="font-bold">{title}</div>
            <div>{description}</div>
          </div>
        </div>
      </AccordionTrigger>
      <AccordionContent className="flex flex-col gap-2">
        {children}
      </AccordionContent>
    </AccordionItem>
  );
}
